import { writable } from 'svelte/store';

export const ANY_DAY = '';
export const ANY_STORE = '';
export const ANY_TAG = '';
export const ANY_WORD = ''
export const NO_ID = ''
export const TRIPLADAYS = "tripladays"

export const filter_by_category = writable(ANY_TAG);
export const filter_by_day = writable(ANY_DAY);
export const filter_by_store = writable(ANY_STORE);
export const filter_by_search = writable(ANY_WORD);
export const filter_by_wishlist = writable(false);
export const campaign_id = writable(NO_ID);
export const campaign_theme = writable(TRIPLADAYS);

export type CampaignNavigation = {
    "1": string;
    "2" : string;
}

export const CATEGORY_NAVIGATION: CampaignNavigation = { "1": "Tripladays campaign - Category pages", "2": "Xmas campaign - Category pages" }
export const DAY_NAVIGATION: CampaignNavigation = { "1": "Tripladays campaign - Day pages", "2": "Xmas campaign - Day pages" }
export const CAMPAIGN_MAIN_NAVIGATION: CampaignNavigation = { "1": "Tripladays campaign - Main navigation", "2": "Xmas campaign - Main navigation" }